import React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';

import { translate } from 'utils/utils';
import Labels from '../../enums/Labels';
import { TafEmailInput } from '@taf-ui/react';
import { TafChangeEvent } from '@taf-ui/core';
import Language from '../../enums/Language';

const InputEmailAddress: React.FunctionComponent<{
  onBlurHandler: () => void;
  lang: Language,
  required?: boolean;
}> = ({ onBlurHandler, lang, required = false }) => (
  <Field name="email">
    {({ input, meta }: FieldRenderProps<string>): React.ReactElement => (
      <TafEmailInput
        label={translate(Labels.PERSONAL_DETAILS_EMAIL, lang)}
        required={required}
        value={input.value}
        name="email"
        inputId="email"
        onTafBlur={() => input.onBlur()}
        onTafChange={(e: CustomEvent<TafChangeEvent<string>>) => {
          input.onChange(e.detail.value);
          onBlurHandler();
        }}
        validationState={meta.error && meta.touched ? 'error' : undefined}
        validationMessage={translate(meta.error as Labels, lang)}
      />
    )}
  </Field>
);

export default InputEmailAddress;
